import { ITimeModel, TimeUnit } from 'gen/ApiClient';
import { ITimeUnitTranslation } from './ITimeUnitTranslation';
import { renderTimeUnitValue } from './renderTimeUnitValue';

export const renderTimeModel = (model: ITimeModel, record: Record<TimeUnit, ITimeUnitTranslation>): string =>
	`${model.value} ${renderTimeUnitValue(model.value, model.unit as TimeUnit, record)}`;
